import {AxiosResponse} from "axios";
import {BaseQueryOptions, BaseUseQueryResult, useBaseQuery} from "@bounce/shared/requests";
import {axiosReachInstance} from "../../ReachApiManager";
import {TEMPLATES_QUERY_KEY, TRIGGER_PREVIEW_QUERY_KEY} from "../queryKeys";
import {TriggerPreviewRequest, TriggerPreviewResponse} from "./types";

const previewTriggerTemplate = async (variables: TriggerPreviewRequest): Promise<TriggerPreviewResponse> => {
  const response = await axiosReachInstance.post<
    TriggerPreviewResponse,
    AxiosResponse<TriggerPreviewResponse>,
    TriggerPreviewRequest
  >("/triggers/preview", variables);
  return response.data;
};

export const usePreviewTriggerTemplate = (
  variables: TriggerPreviewRequest,
  options?: BaseQueryOptions<TriggerPreviewResponse, TriggerPreviewRequest>
): BaseUseQueryResult<TriggerPreviewResponse> =>
  useBaseQuery<TriggerPreviewResponse, TriggerPreviewRequest>(
    [
      TEMPLATES_QUERY_KEY,
      TRIGGER_PREVIEW_QUERY_KEY,
      variables.template_id,
      variables.account_id,
      variables.language,
      JSON.stringify(variables.payload),
    ],
    previewTriggerTemplate,
    variables,
    options
  );
